import $ from 'jquery'
import 'slick-carousel/slick/slick'
import 'slick-carousel/slick/slick.css'
import Config from 'luminate/src/config'
import * as Parser from 'luminate/src/helpers/parser'
import Base from 'luminate/src/modules/base'

const Slick = Base.extend({
	directive: 'slick',

	events: {

		init: function()
		{
			$(this.$element).slick(this.$settings)
		}
	}
})

Slick.getSettings = function(element, owner = null)
{
	const Module = this

	let p = Config.directivePrefix
	let d = Module.directive
	let ref = Module.getReference(element, owner)
	let settings = ''

	if(ref)
	{
		settings = element.getAttribute(`${p}${d}:${ref}`)
	}
	else
	{
		settings = element.getAttribute(`${p}${d}`) || element.getAttribute(d)
	}

	if(/^[{\[].*[}\]]$/.test(settings))
	{
		return JSON.parse(settings)
	}

	return Parser.settings(settings)
}

export default Slick



// WEBPACK FOOTER //
// ./public/scripts/src/modules/slick.js